import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from 'src/admins';
import Errors from 'components/base/errors';
import * as actions from './actions';
import Show from './show';
import Index from './index';

class Container extends React.Component {
  render() {
    return (
      <div className={`${styles.container}`}>
        <Errors errors={this.props.errors} onError={this.props.actions.error} />
        {this.props.eventlog ? (
          <Show eventlog={this.props.eventlog} actions={this.props.actions} />
        ) : (
          <Index
            eventlogs={this.props.eventlogs}
            filter={this.props.filter}
            navi={this.props.navi}
            actions={this.props.actions}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    eventlogs: state.eventlogs,
    eventlog: state.eventlog,
    filter: state.filter,
    navi: state.navi,
    errors: state.errors,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(Container);
